module.exports = __webpack_public_path__ + "img/avatar_default.83fd6e5d.png";